import { CornerDownLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import type { CmdItem } from "./types";

export function CommandItem({
  item,
  active,
  onHover,
}: {
  item: CmdItem;
  active: boolean;
  onHover: () => void;
}) {
  const Icon = item.icon;
  const isCreate = item.category === "Create";
  return (
    <button
      type="button"
      data-cmd-id={item.id}
      onClick={item.onSelect}
      onMouseMove={onHover}
      className={cn(
        "group flex w-full items-center gap-3 px-3 py-2 rounded-xl cursor-pointer text-sm transition-[color,background-color,border-color,box-shadow,opacity,transform,translate,scale,rotate] duration-100 text-left bg-transparent border-0 hover:bg-muted/40 hover:text-foreground focus-visible:outline-none",
        active && "bg-primary/[0.08] text-primary",
      )}
    >
      <span
        className={cn(
          "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg transition-colors",
          isCreate
            ? "bg-primary/10 text-primary group-data-[selected=true]:bg-primary/20"
            : "bg-muted/40 text-muted-foreground group-data-[selected=true]:bg-primary/15 group-data-[selected=true]:text-primary",
          active && (isCreate ? "bg-primary/20" : "bg-primary/15 text-primary"),
        )}
      >
        <Icon size={14} />
      </span>
      <span className="flex-1 font-medium truncate">{item.label}</span>
      {isCreate && (
        <span className="text-[10px] font-medium text-primary/60 uppercase tracking-wide">
          Go
        </span>
      )}
      <CornerDownLeft
        size={12}
        className="text-muted-foreground/30 shrink-0 group-data-[selected=true]:text-primary/50"
      />
    </button>
  );
}
